// extracted by mini-css-extract-plugin
module.exports = {"search-results":"SearchResults_search-results__3fn_e"};